import {NgModule} from '@angular/core';
import {CbViewPdfDialogComponent} from './view-pdf-dialog.component';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
    declarations: [
        CbViewPdfDialogComponent
    ],
    imports: [
        MatIconModule,
        PdfViewerModule,
        MatTooltipModule
    ]
})
export class CbViewPdfDialogModule {
}
